export default async function goToPayment([state, dispatch], navigate) {
    // On demande le passage à la phase de paiement.
    const result = await state.agents.cart.transitionOrderToPayment();
    if (result.id) {
        navigate("/order/payment");
    }
    if (result.errorCode) {
        console.error(result.message);
    }
}